export default __webpack_public_path__ + "static/media/CyberBillstore.aeb7eb55.png";